import { Box, Container, CssBaseline, ThemeProvider } from '@mui/material';
import React from 'react';
import Header from '../../components/Header/Header';
import demoAppTheme from '../../theme/demoAppTheme';

export interface BasicPageProps {
  children: React.ReactNode | React.ReactNode[];
}

export function BasicPage(props: BasicPageProps) {
  return (
    <>
      <ThemeProvider theme={demoAppTheme}>
        <CssBaseline />
        <Header />
        <Container maxWidth="lg">
          <Box className="app-container">{props.children}</Box>
        </Container>
      </ThemeProvider>
    </>
  );
}
